// extracted by mini-css-extract-plugin
export var form = "_e4-0";